"use client";

import { UserProvierSelect, UserRoleSelect, UserStateSelect } from "@/entities";
import { useRouter, useSearchParams } from "next/navigation";
import { useForm, Controller } from "react-hook-form";

export function AdminUsersFilter() {
  const searchParams = useSearchParams();
  const router = useRouter();

  const provider = searchParams?.get(`provider`);
  const role = searchParams?.get(`role`);
  const state = searchParams?.get(`state`);
  const keyword = searchParams?.get(`keyword`);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: { keyword } });

  const onSubmit = async (data: any) => {
    let url = new URL(window.location.href);
    // if (isWithdrawal) url.searchParams.set("isWithdrawal", isWithdrawal);
    if (provider) url.searchParams.set("provider", provider);
    else url.searchParams.delete("provider");
    if (role) url.searchParams.set("role", role);
    else url.searchParams.delete("role");
    if (state) url.searchParams.set("state", state);
    else url.searchParams.delete("state");
    if (data.keyword) url.searchParams.set("keyword", data.keyword);
    else url.searchParams.delete("keyword");
    router.push(url.toString());
  };

  const onProviderChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let url = new URL(window.location.href);
    if (e.target.value) url.searchParams.set("provider", e.target.value);
    else url.searchParams.delete("provider");
    if (role) url.searchParams.set("role", role);
    else url.searchParams.delete("role");
    if (state) url.searchParams.set("state", state);
    else url.searchParams.delete("state");
    if (keyword) url.searchParams.set("keyword", keyword);
    else url.searchParams.delete("keyword");
    router.push(url.toString());
  };

  const onRoleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let url = new URL(window.location.href);
    if (provider) url.searchParams.set("provider", provider);
    else url.searchParams.delete("provider");
    if (e.target.value) url.searchParams.set("role", e.target.value);
    else url.searchParams.delete("role");
    if (state) url.searchParams.set("state", state);
    else url.searchParams.delete("state");
    if (keyword) url.searchParams.set("keyword", keyword);
    else url.searchParams.delete("keyword");
    router.push(url.toString());
  };

  const onStateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let url = new URL(window.location.href);
    if (provider) url.searchParams.set("provider", provider);
    else url.searchParams.delete("provider");
    if (role) url.searchParams.set("role", role);
    else url.searchParams.delete("role");
    if (e.target.value) url.searchParams.set("state", e.target.value);
    else url.searchParams.delete("state");
    if (keyword) url.searchParams.set("keyword", keyword);
    else url.searchParams.delete("keyword");
    router.push(url.toString());
  };

  return (
    <div className="row">
      <div className="col-md-8">
        <div className="row">
          <div className="col-md-3 mb-3">
            <UserProvierSelect
              defaultValue={{ key: "", value: "전체가입" }}
              onChange={onProviderChange}
              value={provider ?? ""}
            />
          </div>
          <div className="col-md-3 mb-3">
            <UserRoleSelect
              defaultValue={{ key: "", value: "전체권한" }}
              onChange={onRoleChange}
              value={role ?? ""}
            />
          </div>
          <div className="col-md-3 mb-3">
            <UserStateSelect
              defaultValue={{ key: "", value: "전체상태" }}
              onChange={onStateChange}
              value={state ?? ""}
            />
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="input-group mb-3">
            <Controller
              control={control}
              name="keyword"
              render={({ field: { onChange, onBlur, value } }) => (
                <input
                  type="text"
                  id="keyword"
                  className="form-control form-control-md"
                  title="검색어(이름, 이메일, 휴대번화)를 입력해주세요."
                  placeholder="검색어(이름, 이메일, 휴대번화) 입력"
                  value={value || ""}
                  onBlur={onBlur}
                  onChange={onChange}
                />
              )}
            />
            <button className="btn btn-white btn-md" type="submit">
              <i className="fa fa-search"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
